module.exports = {
  AvatarPlayer: {
    PluginName: "Avatar",
    avatar: "Avatar",
    avatarName: "Avatar adı",
    poster: "Görsel",
    framing: "Çerçeveleme",
    focalX: "Yatay odak",
    focalY: "Dikey odak",
    radius: "Köşe yuvarlaklığı",
    box_style: "Kutu Stili",
    border: "Çerçeve",
    opacity: "Opaklık",
  },
};
